import { Injectable, Inject } from '@angular/core';
import { loadReCaptcha } from '../utils/load-recaptcha';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaLoaderService {
  private loadedKeys = new Set<string>();

  constructor(@Inject('APP_ENVIRONMENT') private environment: any) {}

  async loadBothRecaptchas(): Promise<void> {
    const generalKey = this.environment.RECAPTCHA_ENTERPRISE_SITE_KEY;
    const transactionKey = this.environment.RECAPTCHA_TRANSACTION_SITE_KEY || '6LdLEWUrAAAAAJAoTB_oavCjnHnZzOU3ZxAw7hhJ';

    // Cargar ambos reCAPTCHAs si no están cargados
    if (!this.loadedKeys.has(generalKey)) {
      await loadReCaptcha(generalKey);
      this.loadedKeys.add(generalKey);
    }

    if (!this.loadedKeys.has(transactionKey)) {
      await loadReCaptcha(transactionKey);
      this.loadedKeys.add(transactionKey);
    }
  }
}